export function getInventoryTurnover(
  annualPartUsage: number | null,
  averageInventoryQuantity: number | null
): number | null {
  if (
    annualPartUsage === null ||
    annualPartUsage <= 0 ||
    averageInventoryQuantity === null ||
    averageInventoryQuantity <= 0
  ) {
    return null;
  }
  return annualPartUsage / averageInventoryQuantity;
}
